"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRow = exports.StyledHead = exports.StyleTableLoader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyleTableLoader = _styledComponents.default.div.withConfig({
  displayName: "TableLoaderstyle__StyleTableLoader",
  componentId: "sc-4ivjey-0"
})(["display:flex;background:", ";flex-direction:column;.table-item{margin-right:88px;:last-child{margin:0;}}"], _shared.theme.palette.brand.primary.white);

exports.StyleTableLoader = StyleTableLoader;

const StyledRow = _styledComponents.default.div.withConfig({
  displayName: "TableLoaderstyle__StyledRow",
  componentId: "sc-4ivjey-1"
})(["box-sizing:border-box;display:flex;flex-direction:row;padding:27px 58px 27px 112px;align-items:center;box-shadow:inset 0px -1px 0px rgba(115,127,143,0.1);justify-content:space-evenly;"]);

exports.StyledRow = StyledRow;

const StyledHead = _styledComponents.default.div.withConfig({
  displayName: "TableLoaderstyle__StyledHead",
  componentId: "sc-4ivjey-2"
})(["position:relative;font-size:13px;line-height:16px;letter-spacing:0.02em;color:", ";width:", ";height:", ";display:inline-flex;align-items:center;word-wrap:break-word;:first-child{:before{content:'#';position:absolute;left:-50px;top:0px;}}"], _shared.theme.palette.brand.primary.gray, ({
  index,
  length
}) => index === '1' ? '40%' : `calc(60%/${length - 1})`, ({
  height
}) => height && height);

exports.StyledHead = StyledHead;